import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { MotionProvider, ToastProvider } from '@redpandev/ui';
// Polices auto-hébergées (CSP-friendly, pas de CDN) — spec 05 §2.2.
import '@fontsource-variable/fredoka';
import '@fontsource-variable/inter';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/700.css';
import App from './App';
import { AuthProvider } from './auth/AuthContext';
import { PwaUpdatePrompt } from './app/PwaUpdatePrompt';
import { InstallPromptProvider } from './components/pwa/InstallPromptProvider';
import { ThemeProvider } from './app/theme/ThemeProvider';
import './index.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Élément #root introuvable');

createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <MotionProvider>
          <ToastProvider>
            <AuthProvider>
              <InstallPromptProvider>
                <App />
              </InstallPromptProvider>
              <PwaUpdatePrompt />
            </AuthProvider>
          </ToastProvider>
        </MotionProvider>
      </ThemeProvider>
    </BrowserRouter>
  </StrictMode>,
);
